/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./file.view.pdf.component";
import * as i2 from "./providers/files.provider";
import * as i3 from "./providers/image.ready.service";
import * as i4 from "@angular/platform-browser";
var styles_FileViewPdfComponent = [];
var RenderType_FileViewPdfComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_FileViewPdfComponent, data: {} });
export { RenderType_FileViewPdfComponent as RenderType_FileViewPdfComponent };
export function View_FileViewPdfComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\n    "])), (_l()(), i0.ɵeld(1, 0, null, null, 0, "iframe", [["height", "100%"], ["width", "100%"]], [[8, "src", 5]], null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n  "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.url; _ck(_v, 1, 0, currVal_0); }); }
export function View_FileViewPdfComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "file-view-pdf", [], null, [["window", "resize"]], function (_v, en, $event) { var ad = true; if (("window:resize" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1).onResize($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_FileViewPdfComponent_0, RenderType_FileViewPdfComponent)), i0.ɵdid(1, 114688, null, 0, i1.FileViewPdfComponent, [i2.FilesProvider, i3.ImageReadyService, i4.DomSanitizer], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FileViewPdfComponentNgFactory = i0.ɵccf("file-view-pdf", i1.FileViewPdfComponent, View_FileViewPdfComponent_Host_0, { file: "file", ready: "ready" }, {}, []);
export { FileViewPdfComponentNgFactory as FileViewPdfComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/file.view.pdf.component.ngfactory.js.pre-build-optimizer.js